import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { LinkButton } from '../SolvPatternLibrary/Button/BaseButton';
import { ButtonVariations } from '../SolvPatternLibrary/Button';
import { colors } from '../../constants/colors';
import InsuranceCard from './InsuranceCard';
import InsuranceCardShape from '../../shapes/InsuranceCard';
import { IMAGE_TYPE_FRONT, IMAGE_TYPE_BACK } from '../../constants';
import FileUpload from '../SolvPatternLibrary/FileUpload';

const CTA = 'cta';
const FRONT_UPLOADED = 'frontUploaded';
const FRONT_SCANNING = 'frontScanning';
const BACK_UPLOADED = 'backUploaded';
const BACK_SCANNING = 'backScanning';

const UploadAndScanButton = styled(LinkButton)`
  margin-left: auto;
  margin-right: auto;
`;

const InfoMessage = styled.div`
  margin-top: 20px;
  color: ${colors.blueMonday};
`;

const ScanInsuranceCTA = styled.div`
  text-align: center;
`;

const FileInput = styled(FileUpload)`
  position: absolute;
  width: 160px;
  top: 0;
  left: 0;
  opacity: 0.01;
  border: none;
  z-index: 1;
  cursor: pointer;
  height: 38px;
  font-size: 0;
`;

const ScanButtonContainer = styled.span`
  position: relative;
  width: 170px;
  margin: auto;
`;

const StyledCardContainer = styled(Grid)`
  display: flex;
  justify-content: space-evenly;
`;

const StyledGrid = styled(Grid)`
  width: 100%;
`;

class InsuranceFileUpload extends Component {
  render = () => {
    let view;
    const { insuranceCard, handleFileChange, onClickFront, onClickBack } = this.props;

    if (insuranceCard.front.scanStarted) {
      view = FRONT_SCANNING;
    }

    switch (view) {
      case FRONT_SCANNING:
        return (
          <StyledCardContainer item xs={12}>
            <InsuranceCard
              onClick={onClickFront}
              cardImage={insuranceCard.front.base64}
              scanCompleted={insuranceCard.front.scanCompleted}
              scanStarted={insuranceCard.front.scanStarted}
              handleFileChange={handleFileChange(IMAGE_TYPE_FRONT)}
            />
            {insuranceCard.front.scanStarted && (
              <InsuranceCard
                onClick={onClickBack}
                cardImage={insuranceCard.back.base64}
                scanCompleted={insuranceCard.back.scanCompleted}
                scanStarted={insuranceCard.back.scanStarted}
                handleFileChange={handleFileChange(IMAGE_TYPE_BACK)}
                buttonStyle={ButtonVariations.tertiary}
                showPlaceholder
                placeholderImage="/images/insurance/back_copy.svg"
              >
                Scan back of card
              </InsuranceCard>
            )}
          </StyledCardContainer>
        );
      default:
        return (
          <StyledGrid container justify="center" spacing={24}>
            <Grid item xs={12}>
              <ScanInsuranceCTA>
                <InfoMessage>Have a photo of the front of your card?</InfoMessage>
                <ScanButtonContainer>
                  <FileInput
                    type={'file'}
                    accept={'image/*'}
                    onChange={handleFileChange(IMAGE_TYPE_FRONT)}
                  />
                  <UploadAndScanButton disableRipple>Upload Image</UploadAndScanButton>
                </ScanButtonContainer>
              </ScanInsuranceCTA>
            </Grid>
          </StyledGrid>
        );
    }
  };
}

InsuranceFileUpload.propTypes = {
  insuranceCard: InsuranceCardShape,
  handleFileChange: PropTypes.func,
  onClickFront: PropTypes.func,
  onClickBack: PropTypes.func,
};

export default InsuranceFileUpload;
